import { useReduxState } from 'hooks';
import { TitleWithIcon } from 'components/common';

const PageSidebarTitle = ({ icon, subtitle, title }) => {
  const { theme } = useReduxState();

  return (
    <div className="sidebar-title">
      <TitleWithIcon icon={icon} title={title}>
        {subtitle}
      </TitleWithIcon>

      <style jsx>{`
        .sidebar-title {
          border-bottom: 1px solid ${theme.lightGrey};
          padding: 20px 15px;
        }
      `}</style>
    </div>
  );
};

export default PageSidebarTitle;
